import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useLogin } from '~/hooks/useLogin'

import LoginView from './loginView'

export default function LoginController() {
  const [credential, setCredential] = useState({
    email: '',
    password: '',
  })
  let history = useHistory()
  const { sigIn } = useLogin()

  function handleChange(event) {
    setCredential({
      ...credential,
      [event.target.name]: event.target.value,
    })
  }

  async function handleSubmit(event) {
    event.preventDefault()

    sigIn({
      email: credential.email,
      password: credential.password,
    }).then((res) => {
      if (res === 'success') return history.push(`/`)
    })
  }

  return (
    <LoginView
      email={credential.email}
      password={credential.password}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  )
}
